function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    // if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.onTabChange()
  }

  onTabChange() {
    const collectionFilter = document.querySelector('.slide-panel__filter');

    this.trapFocus(collectionFilter)
  }

  trapFocus(dialog) {

    const focusableElements = dialog.querySelectorAll('a, button, select, textarea, [tabindex]:not([tabindex="-1"])');

    const removeHiddenButtons = [...focusableElements].filter((el) => {
      const parent = el.parentElement;
      return !parent.classList.contains('hidden');
    });

    const firstFocusableElement = removeHiddenButtons[0];
    const lastFocusableElement = removeHiddenButtons[removeHiddenButtons.length - 1];

    dialog.addEventListener('keydown', (e) => {

      if (e.key === 'Enter') {
        const list = e.target;
        // const input = list?.querySelector('input');
        if (!list?.disabled) {
            list.checked = !list.checked;
          this.onSubmitHandler(e)
        }
      }

      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            e.preventDefault();
            lastFocusableElement.focus();
          }
        } else {
          // eslint-disable-next-line
          if (document.activeElement === lastFocusableElement) {
            e.preventDefault();
            firstFocusableElement.focus();
            this.trapFocus(dialog)
          }
        }

        if (document.activeElement === lastFocusableElement) {
          e.preventDefault();
          firstFocusableElement.focus();
        }
      }
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);

    document.querySelector('#filter-apply-btn')?.addEventListener('click',()=>{
      document.querySelector('.collection__filters-close').click()
      document.querySelector('slide-panel[slidepanelid="toggle-filters"]').setAttribute('default-open', 'false');
    })
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();


    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }


  static renderProductGridContainer(html) {
    const container = document.getElementById('ProductGridContainer');

    container.innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    container.querySelectorAll('.scroll-trigger')
      .forEach((el) => el.classList.add('scroll-trigger--cancel'));

    // ВАЖНО: уведомляем пагинацию, что грид обновлён
    document.dispatchEvent(new CustomEvent('collection:updated', {
      detail: { source: 'facets' }
    }));
  }


  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
        '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
        '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Store the last focused input information before DOM updates
    let lastFocusedInputInfo = null;
    if (event && event.target) {
      const targetInput = event.target.closest('input[type="checkbox"]') || event.target;
      if (targetInput && targetInput.name) {
        lastFocusedInputInfo = {
          name: targetInput.name,
          value: targetInput.value,
          id: targetInput.id
        };
      }
    }

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);

      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
            ? `.mobile-facets__close-button`
            : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }

    // Restore focus to the last chosen input after DOM updates
    setTimeout(() => {
      if (lastFocusedInputInfo) {
        let inputToFocus = null;

        // Try to find by ID first
        if (lastFocusedInputInfo.id) {
          inputToFocus = document.getElementById(lastFocusedInputInfo.id);
        }

        // If not found by ID, try to find by name and value
        if (!inputToFocus && lastFocusedInputInfo.name) {
          const inputs = document.querySelectorAll(`input[name="${lastFocusedInputInfo.name}"]`);
          inputs.forEach(input => {
            if (input.value === lastFocusedInputInfo.value) {
              inputToFocus = input;
            }
          });
        }

        // If still not found, try to find by name only (useful for newly rendered elements)
        if (!inputToFocus && lastFocusedInputInfo.name) {
          inputToFocus = document.querySelector(`input[name="${lastFocusedInputInfo.name}"]`);
        }

        // Focus the element if found
        if (inputToFocus) {
          inputToFocus.focus();
        }
      }
    }, 150);
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({searchParams}, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);

    // Remove empty price range values before appending to URL
    const priceMinKey = Array.from(formData.keys()).find(k => k.includes('filter.v.price.gte'));
    const priceMaxKey = Array.from(formData.keys()).find(k => k.includes('filter.v.price.lte'));

    if (priceMinKey && !formData.get(priceMinKey)) {
      formData.delete(priceMinKey);
    }
    if (priceMaxKey && !formData.get(priceMaxKey)) {
      formData.delete(priceMaxKey);
    }

    return new URLSearchParams(formData).toString();
  }


  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    this.selectedFilters = document.querySelectorAll('input[name^="filter"]:checked').length;
    document.getElementById('selected-items-count').innerHTML = this.selectedFilters > 0 ? `(${this.selectedFilters})` : '';

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');

    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = false

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
if (!customElements.get('facet-filters-form')) {
  customElements.define('facet-filters-form', FacetFiltersForm);
}
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();

    const [minInput, maxInput] = this.querySelectorAll('input');
    this.minInput = minInput;
    this.maxInput = maxInput;

    this._updating = false;

    this.defaults = {
      minMin: minInput.getAttribute('min'),
      minMax: minInput.getAttribute('max'),
      maxMin: maxInput.getAttribute('min'),
      maxMax: maxInput.getAttribute('max'),
    };

    this.onRangeInput = this.onRangeInput.bind(this);
    this.onRangeChange = this.onRangeChange.bind(this);

    this.minInput.addEventListener('input', this.onRangeInput);
    this.maxInput.addEventListener('input', this.onRangeInput);

    this.minInput.addEventListener('change', this.onRangeChange);
    this.maxInput.addEventListener('change', this.onRangeChange);

    this.setMinAndMaxValues({soft: true});

  }

  onRangeInput(e) {
    if (!e.isTrusted || this._updating) return;
    this.setMinAndMaxValues({soft: true});
  }

  onRangeChange(e) {

    if (!e.isTrusted || this._updating) return;
    this._updating = true;

    try {
      const edited = e.currentTarget;

      const beforeMin = this.minInput.value;
      const beforeMax = this.maxInput.value;

      this.adjustToValidValues(edited);
      this.setMinAndMaxValues({soft: false});

      this.dispatchChange(edited);

      if (this.minInput.value !== beforeMin) this.dispatchChange(this.minInput);
      if (this.maxInput.value !== beforeMax) this.dispatchChange(this.maxInput);

      const form = this.closest('form');
      if (form) this.dispatchChange(form);
    } finally {
      this._updating = false;
    }
  }

  dispatchChange(el) {
    setTimeout(() => {
      el.dispatchEvent(new Event('change', {bubbles: true}));
    }, 0);
  }

  setMinAndMaxValues({soft = false} = {}) {
    const minRaw = this.minInput.value.trim();
    const maxRaw = this.maxInput.value.trim();

    const hasMin = minRaw !== '' && !Number.isNaN(Number(minRaw));
    const hasMax = maxRaw !== '' && !Number.isNaN(Number(maxRaw));

    if (hasMax) {
      this.minInput.setAttribute('max', maxRaw);
    } else if (this.defaults.minMax != null) {
      this.minInput.setAttribute('max', this.defaults.minMax);
    } else {
      this.minInput.removeAttribute('max');
    }

    if (hasMin) {
      this.maxInput.setAttribute('min', minRaw);
    } else if (this.defaults.maxMin != null) {
      this.maxInput.setAttribute('min', this.defaults.maxMin);
    } else {
      this.maxInput.removeAttribute('min');
    }

    if (!soft && hasMin && hasMax && Number(minRaw) > Number(maxRaw)) {
      this.maxInput.value = minRaw;
    }
  }

  adjustToValidValues(input) {
    const raw = input.value.trim();
    if (raw === '') return;

    const value = Number(raw);
    if (Number.isNaN(value)) return;

    const minAttr = input.getAttribute('min');
    const maxAttr = input.getAttribute('max');

    const min = minAttr === null || minAttr === '' ? -Infinity : Number(minAttr);
    const max = maxAttr === null || maxAttr === '' ? Infinity : Number(maxAttr);

    if (value < min) input.value = String(min);
    if (value > max) input.value = String(max);
  }
}

if (!customElements.get('price-range')) {
  customElements.define('price-range', PriceRange);
}


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

if (!customElements.get('facet-remove')) {
  customElements.define('facet-remove', FacetRemove);
}
